import ButtonLegacy from "./ButtonLegacy";
import { ButtonPropsLegacy, ThemeLegacy } from "./interfaceLegacy";
import ButtonGroupCTA from "./ButtonGroupCTA";
import Button from "./Button";

export type { ButtonPropsLegacy, ThemeLegacy };
export { Button, ButtonGroupCTA };
export default ButtonLegacy;
